module.exports = __webpack_public_path__ + "static/media/Artificial Colour.7b3fa302.jpg";